import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import Big from 'big.js';
import { shopsApi, StoreResponse, StoreResponses } from '@/stores/api';
import ErrorKey from '@/util/ErrorKey';
import { DeliveryMethodDto, PaymentMethodDto, ShopSettingsDto } from '@/api';
import { ShopContext } from '@/util/ShopContext';

@Module({
  namespaced: true,
  name: 'ShopStore',
})
export default class ShopStore extends VuexModule {
  private minOrderValueSetting: Big = new Big(0);
  private paymentMethodsSetting: PaymentMethodDto[] = [];
  private deliveryMethodsSetting: DeliveryMethodDto[] = [];
  private deliveryDeadlineInfoThresholdSetting: number = 0;
  private loading = true;

  get minOrderValue(): Big {
    return this.minOrderValueSetting;
  }

  get paymentMethods(): PaymentMethodDto[] {
    return this.paymentMethodsSetting;
  }

  get deliveryMethods(): DeliveryMethodDto[] {
    return this.deliveryMethodsSetting;
  }

  get deliveryDeadlineInfoThreshold(): number {
    return this.deliveryDeadlineInfoThresholdSetting;
  }

  @Action
  public async fetchShopSettings(): Promise<StoreResponse<ShopSettingsDto>> {
    this.setLoading(true);
    try {
      if (ShopContext.shopCode) {
        const response = await shopsApi.getSettings(ShopContext.shopCode);
        this.context.commit('updateFromDto', response.data);
        return StoreResponses.apiSuccess(response);
      } else {
        return StoreResponses.forErrorKey(ErrorKey.ShopMinOrderValueFetchAction);
      }
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.ShopMinOrderValueFetchAction);
    } finally {
      this.setLoading(false);
    }
  }

  @Mutation
  private updateFromDto(shopSettingsDto: ShopSettingsDto) {
    this.minOrderValueSetting = new Big(shopSettingsDto.minOrderValue);
    this.paymentMethodsSetting = shopSettingsDto.paymentMethods;
    this.deliveryMethodsSetting = shopSettingsDto.deliveryMethods;
    this.deliveryDeadlineInfoThresholdSetting = shopSettingsDto.deliveryDeadlineInfoInterval;
  }

  get isLoading(): boolean {
    return this.loading;
  }

  @Mutation
  private setLoading(loading: boolean) {
    this.loading = loading;
  }
}
